import { render, staticRenderFns } from "./HealthCenter.vue?vue&type=template&id=c952a32a&scoped=true&"
var script = {}
import style0 from "./HealthCenter.vue?vue&type=style&index=0&id=c952a32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c952a32a",
  null
  
)

export default component.exports